import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { RouteInfo } from "src/app/shared/sidebar/sidebar.metadata";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class OpAdminCheckoutService {
  myHeaders = this.setHeader();
  setHeader() {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    return headers;
  }
  constructor(private http: HttpClient) { }
  getCodeList() {
    let url = environment.URL + "/code/country";
    return this.http.get(url, { headers: this.myHeaders });
  }
  getPaymentList() {
    let url = environment.URL + "/code/payment_type";
    return this.http.get(url, { headers: this.myHeaders });
  }
  getPostageCost(proofcardIds) {
    if (proofcardIds == undefined || proofcardIds === "" || proofcardIds == null) {
      proofcardIds = null;
    }

    let url = environment.URL + "/postageCost/" + proofcardIds;
    return this.http.get(url, { headers: this.myHeaders});
  }
  updateOrderDetails(bodyParams) {
    let url = environment.URL + "/order/update";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }
}
